import React from 'react';
import { useNavigate } from 'react-router-dom';

import {
  DropdownMenuContent as ShadcnDropdownMenuContent,
  DropdownMenuLabel,
} from '@/components/ui/dropdown-menu';
import { useSidebar } from '@/components/ui/sidebar';
import { useAuth } from '../../../../../../../../../shared/hooks';
import { AvatarWithEmail } from '../../../../../../../../../shared/components/Avatar';
import { logout as apiLogout } from '../../../../../../../../pages/Auth/services/sessionService';
import { LOGIN } from '../../../../../../../constants';
import { DROPDOWN_MENU_CONTENT_CLASSES, USER_SELECT_LINKS } from '../../../../constants';
import { userShape } from '../../../../types';
import LinkGroup from './LinkGroup';

const DropdownMenuContent = ({ user }) => {
  const { clearSession } = useAuth();
  const navigate = useNavigate();
  const { isMobile } = useSidebar();

  const { avatarColor, email, fullName, initials } = user;

  const avatarProps = {
    avatarColor,
    email,
    fullName,
    initials,
  };

  const onLogout = async () => {
    await apiLogout();
    clearSession();
    navigate(LOGIN);
  };

  const getClickHandler = (link) => {
    if (link.action === 'logout') {
      return onLogout;
    }

    if (link.path) {
      return () => navigate(link.path);
    }

    return undefined;
  };

  return (
    <ShadcnDropdownMenuContent
      align="end"
      className={DROPDOWN_MENU_CONTENT_CLASSES}
      side={isMobile ? 'bottom' : 'right'}
      sideOffset={4}
    >
      <DropdownMenuLabel className="font-normal px-1 py-1.5">
        <AvatarWithEmail {...avatarProps} />
      </DropdownMenuLabel>

      {USER_SELECT_LINKS.map(({ groupName, links }) => (
        <LinkGroup
          key={groupName}
          links={links.map((link) => ({
            ...link,
            onClick: getClickHandler(link),
          }))}
        />
      ))}
    </ShadcnDropdownMenuContent>
  );
};

DropdownMenuContent.propTypes = {
  user: userShape.isRequired,
};

export default DropdownMenuContent;
